export default __webpack_public_path__ + "static/media/trackinfo_racingline.8a32c34b.webp";